<div class="address-with-unit-container">
  <div class="unit">
    <label for="unitNumber">
      Unit #
    </label>
    <div class="p-inputgroup mt-05">
      <input
        #unitNumber
        type="text"
        pInputText
        [ngModel]="(billingAddress$ | async)?.addressLineTwo"
        [style]="{ 'marginTop': '0.5rem' }"
        (ngModelChange)="onUnitNumberEntered($event, locationType)"
        class="no-min-width"
      />
    </div>
  </div>
  <div class="address">
    <label for="#address">Address</label>
    <div class="p-inputgroup">
      <input
        #address
        *ngIf="googleHelper.loaded | async"
        [ngModel]="(billingAddress$ | async)?.addressLineOne"
        #googleAutocomplete="ngx-places"
        ngx-gp-autocomplete
        pInputText
        autocomplete="off"
        (onAddressChange)="onAddressSelected($event, locationType)"
        (input)="onInput(locationType)"
        [inputStyle]="{ width: '100%' }"
        [ngClass]="{
          'ng-invalid': (locationInvalid$ | async)
        }"
      />
      <button
        type="button"
        pButton
        pRipple
        (click)="openManualLocation(locationType)"
        icon="pi pi-map-marker"
        class="p-button-secondary p-button-outlined"
        pTooltip="Add a location without using the autocomplete"
      ></button>
    </div>
  </div>
</div>
<small *ngIf="(locationInvalid$ | async)">
  You must use autocomplete to set the location.
</small>

<app-jobv2-manually-add-location
  #addLocation
  [formType]="locationTypeToOpenInManual"
></app-jobv2-manually-add-location>